import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import Section1 from '../../components/HomePage/Section1';
import Section2 from '../../components/HomePage/Section2';
import Section3 from '../../components/HomePage/Section3';
import Section4 from '../../components/HomePage/Section4';
import Section5 from '../../components/HomePage/Section5';
import Section6 from '../../components/HomePage/Section6';
import Section7 from '../../components/HomePage/Section7';
import Section8 from '../../components/HomePage/Section8';
import StoreModal from '../../components/HomePage/StoreModal';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import useScrollToTop from '../../hooks/useScrollToTop';

function HomePage() {
  useScrollToTop();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleSelectStore = (storeLink) => {
    window.open(storeLink, '_blank', 'noopener,noreferrer');
    closeModal();
  };

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        const defaultOffset = 50;
        const sobreNosOffset = 110;
        const offset = id === 'sobre-nos' ? sobreNosOffset : defaultOffset;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        setTimeout(() => {
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="HomePage">
      <main>
        <Section1 openModal={openModal} />
        <Section2 openModal={openModal} id="beneficios" />
        <Section3 openModal={openModal} id="metodologia" />
        <Section4 openModal={openModal} />
        <Section5 openModal={openModal} />
        <Section6 openModal={openModal} id="certificados" />
        <Section7 />
        <Section8 />
      </main>
      <Footer />
      <StoreModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSelectStore={handleSelectStore}
      />
      <ScrollToTopButton />
    </div>
  );
}

export default HomePage;
